<template>
  <div class="interest">
    <div
      v-if="topBannerInterestImg"
      class="interest-banner"
      :style="{ backgroundImage: 'url(' + topBannerInterestImg + ')' }"
    ></div>
    <introduction
      :hasOpenThatBank="hasOpenThatBank"
      :bankName="bankName"
      :bankType="bankType"
      :currentBankHasBinding="currentBankHasBinding"
      :couponPackage="couponPackage"
      :applyPageType="applyPageType"
      :pageABStrategy="pageABStrategy"
      :pushSubWalletABStrategy="pushSubWalletABStrategy"
    />
    <bottom-button
      v-if="!currentBankHasBinding"
      :mobileMask="mobileMask"
      :bankName="bankName"
      :bankType="bankType"
      :hasOpenThatBank="hasOpenThatBank"
      :couponPackage="couponPackage"
      :applyPageType="applyPageType"
      :pageABStrategy="pageABStrategy"
      :pushSubWalletABStrategy="pushSubWalletABStrategy"
    />
  </div>
</template>
<script>
import Introduction from './components/Introduction.vue';
import BottomButton from './components/BottomButton.vue';
export default {
  components: {
    Introduction,
    BottomButton
  },
  props: {
    currentBankHasBinding: {
      type: Boolean,
      default: false
    },
    hasOpenThatBank: {
      type: Boolean,
      default: false
    },
    mobileMask: {
      type: String,
      default: ''
    },
    bankType: {
      type: String,
      default: ''
    },
    bankName: {
      type: String,
      default: ''
    },
    couponPackage: {
      type: Object,
      default: () => {}
    },
    applyPageType: {
      type: String,
      default: ''
    },
    pageABStrategy: {
      type: String,
      default: ''
    },
    pushSubWalletABStrategy: {
      type: String,
      default: ''
    },
    couponImgForTNConfig: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    topBannerInterestImg() {
      if (!this.hasOpenThatBank) {
        return this.couponImgForTNConfig.notOpen;
      }
      if (!this.currentBankHasBinding) {
        return this.couponImgForTNConfig.hasOpen;
      }
      if (this.currentBankHasBinding) {
        return this.couponImgForTNConfig.hasBind;
      }
      return '';
    }
  }
};
</script>
<style scoped lang="less">
.interest {
  padding-bottom: 3.8rem;
  margin: 0 auto;
  &-banner {
    width: 6.9rem;
    height: 5.11rem;
    background-size: 100% auto;
    background-repeat: no-repeat;
    margin-bottom: 0.28rem;
  }
}
</style>
